import { render, staticRenderFns } from "./BindsChip.vue?vue&type=template&id=76b81cb2&"
import script from "./BindsChip.vue?vue&type=script&lang=js&"
export * from "./BindsChip.vue?vue&type=script&lang=js&"
import style0 from "./BindsChip.vue?vue&type=style&index=0&id=76b81cb2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports